import React, { useState } from 'react';
import { Package, Plus, ShoppingBag, DollarSign, TrendingUp, Eye, Edit2, Trash2, Download, BarChart3, Star, FileText, Video, Link as LinkIcon, X, CheckCircle2, Clock, AlertCircle } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { Input } from '../ui/Input';
import { ImageUpload } from '../ui/ImageUpload';
import { initialMarketplaceProducts, initialMarketplaceOrders, initialMarketplacePayouts } from '../../data/marketplaceMockData';
interface MarketplaceTabProps {
  showToast: (msg: string) => void;
}
export function MarketplaceTab({
  showToast
}: MarketplaceTabProps) {
  const [activeSubTab, setActiveSubTab] = useState<'products' | 'create' | 'sales' | 'balance' | 'analytics'>('products');
  // Filter mock data for current astrologer (AST-1)
  const myProducts = initialMarketplaceProducts.filter(p => p.authorId === 'AST-1');
  const myOrders = initialMarketplaceOrders.filter(o => o.sellerId === 'AST-1');
  const myPayouts = initialMarketplacePayouts.filter(p => p.sellerId === 'AST-1');
  // Form state for creating a product
  const [newProduct, setNewProduct] = useState({
    title: '',
    type: 'курс',
    category: '',
    price: '',
    shortDesc: '',
    fullDesc: '',
    targetAudience: '',
    language: 'Русский'
  });
  const [materials, setMaterials] = useState<{
    type: string;
    name: string;
    size: string;
  }[]>([]);
  const [newMaterial, setNewMaterial] = useState({
    type: 'video',
    name: '',
    size: ''
  });
  const [whatUserGets, setWhatUserGets] = useState<string[]>([]);
  const [newBenefit, setNewBenefit] = useState('');
  const handleAddMaterial = () => {
    if (!newMaterial.name) return;
    setMaterials([...materials, newMaterial]);
    setNewMaterial({
      type: 'video',
      name: '',
      size: ''
    });
  };
  const handleRemoveMaterial = (index: number) => {
    setMaterials(materials.filter((_, i) => i !== index));
  };
  const handleAddBenefit = () => {
    if (!newBenefit) return;
    setWhatUserGets([...whatUserGets, newBenefit]);
    setNewBenefit('');
  };
  const handleRemoveBenefit = (index: number) => {
    setWhatUserGets(whatUserGets.filter((_, i) => i !== index));
  };
  const handleSaveDraft = () => {
    showToast('Черновик успешно сохранен');
    setActiveSubTab('products');
  };
  const handleSendToModeration = () => {
    showToast('Товар отправлен на модерацию');
    setActiveSubTab('products');
  };
  const renderTopStats = () => <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6" data-id="element-11832">
      <Card padding="sm" className="bg-white border-slate-200" data-id="element-11833">
        <div className="flex items-center gap-3" data-id="element-11834">
          <div className="w-10 h-10 rounded-full bg-indigo-50 flex items-center justify-center text-indigo-600" data-id="element-11835">
            <Package className="w-5 h-5" data-id="element-11836" />
          </div>
          <div data-id="element-11837">
            <div className="text-xs text-slate-500 uppercase tracking-wider font-semibold" data-id="element-11838">
              Мои товары
            </div>
            <div className="text-xl font-bold text-slate-900" data-id="element-11839">
              {myProducts.length}
            </div>
          </div>
        </div>
      </Card>
      <Card padding="sm" className="bg-white border-slate-200" data-id="element-11840">
        <div className="flex items-center gap-3" data-id="element-11841">
          <div className="w-10 h-10 rounded-full bg-emerald-50 flex items-center justify-center text-emerald-600" data-id="element-11842">
            <ShoppingBag className="w-5 h-5" data-id="element-11843" />
          </div>
          <div data-id="element-11844">
            <div className="text-xs text-slate-500 uppercase tracking-wider font-semibold" data-id="element-11845">
              Продажи всего
            </div>
            <div className="text-xl font-bold text-slate-900" data-id="element-11846">450</div>
          </div>
        </div>
      </Card>
      <Card padding="sm" className="bg-white border-slate-200" data-id="element-11847">
        <div className="flex items-center gap-3" data-id="element-11848">
          <div className="w-10 h-10 rounded-full bg-amber-50 flex items-center justify-center text-amber-600" data-id="element-11849">
            <TrendingUp className="w-5 h-5" data-id="element-11850" />
          </div>
          <div data-id="element-11851">
            <div className="text-xs text-slate-500 uppercase tracking-wider font-semibold" data-id="element-11852">
              Общий доход
            </div>
            <div className="text-xl font-bold text-slate-900" data-id="element-11853">3 150 000 ₽</div>
          </div>
        </div>
      </Card>
      <Card padding="sm" className="bg-white border-slate-200" data-id="element-11854">
        <div className="flex items-center gap-3" data-id="element-11855">
          <div className="w-10 h-10 rounded-full bg-sky-50 flex items-center justify-center text-sky-600" data-id="element-11856">
            <DollarSign className="w-5 h-5" data-id="element-11857" />
          </div>
          <div data-id="element-11858">
            <div className="text-xs text-slate-500 uppercase tracking-wider font-semibold" data-id="element-11859">
              Баланс к выводу
            </div>
            <div className="text-xl font-bold text-slate-900" data-id="element-11860">45 000 ₽</div>
          </div>
        </div>
      </Card>
    </div>;
  const renderProducts = () => <div className="space-y-4" data-id="element-11861">
      <div className="flex justify-between items-center mb-4" data-id="element-11862">
        <h3 className="text-lg font-bold text-slate-900" data-id="element-11863">Каталог товаров</h3>
        <Button icon={<Plus className="w-4 h-4" data-id="element-11865" />} onClick={() => setActiveSubTab('create')} data-id="element-11864">
          Создать товар
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-11866">
        {myProducts.map(product => <Card key={product.id} padding="none" className="flex flex-col overflow-hidden" data-id="element-11867">
            <div className={`h-24 ${product.coverColor} relative flex items-center justify-center`} data-id="element-11868">
              <Package className="w-10 h-10 text-slate-700 opacity-20" data-id="element-11869" />
              <div className="absolute top-3 left-3 flex gap-2" data-id="element-11870">
                <Badge variant="neutral" className="bg-white/90 backdrop-blur-sm text-slate-800 border-none shadow-sm capitalize" data-id="element-11871">
                  {product.type}
                </Badge>
                <Badge variant={product.status === 'active' ? 'success' : product.status === 'moderation' ? 'warning' : 'neutral'} className="shadow-sm" data-id="element-11872">
                  {product.status === 'active' ? 'Активен' : product.status === 'moderation' ? 'На модерации' : 'Черновик'}
                </Badge>
              </div>
            </div>

            <div className="p-4 flex-1 flex flex-col" data-id="element-11873">
              <h4 className="font-bold text-slate-900 line-clamp-2 mb-2" title={product.title} data-id="element-11874">
                {product.title}
              </h4>
              <div className="text-lg font-bold text-indigo-600 mb-4" data-id="element-11875">
                {product.price}
              </div>

              <div className="grid grid-cols-2 gap-3 mb-4 p-3 bg-slate-50 rounded-lg border border-slate-100" data-id="element-11876">
                <div data-id="element-11877">
                  <div className="text-[10px] text-slate-500 uppercase tracking-wider font-semibold mb-0.5" data-id="element-11878">
                    Продажи
                  </div>
                  <div className="font-bold text-slate-900" data-id="element-11879">
                    {product.salesCount} шт.
                  </div>
                </div>
                <div data-id="element-11880">
                  <div className="text-[10px] text-slate-500 uppercase tracking-wider font-semibold mb-0.5" data-id="element-11881">
                    Доход
                  </div>
                  <div className="font-bold text-emerald-600" data-id="element-11882">
                    {product.revenue}
                  </div>
                </div>
                <div data-id="element-11883">
                  <div className="text-[10px] text-slate-500 uppercase tracking-wider font-semibold mb-0.5" data-id="element-11884">
                    Рейтинг
                  </div>
                  <div className="flex items-center gap-1" data-id="element-11885">
                    <Star className="w-3.5 h-3.5 text-amber-400 fill-amber-400" data-id="element-11886" />
                    <span className="font-bold text-slate-900 text-sm" data-id="element-11887">
                      {product.rating}
                    </span>
                    <span className="text-xs text-slate-400" data-id="element-11888">
                      ({product.reviewsCount})
                    </span>
                  </div>
                </div>
                <div data-id="element-11889">
                  <div className="text-[10px] text-slate-500 uppercase tracking-wider font-semibold mb-0.5" data-id="element-11890">
                    Материалы
                  </div>
                  <div className="font-medium text-slate-700 text-sm" data-id="element-11891">
                    {product.materials.length} файла
                  </div>
                </div>
              </div>

              <div className="mt-auto flex gap-2" data-id="element-11892">
                <Button variant="outline" size="sm" className="flex-1" icon={<Edit2 className="w-4 h-4" data-id="element-11894" />} data-id="element-11893">
                  Редактировать
                </Button>
                <Button variant="outline" size="sm" className="px-3" title="Аналитика" icon={<BarChart3 className="w-4 h-4" data-id="element-11896" />} onClick={() => setActiveSubTab('analytics')} data-id="element-11895" />
                <Button variant="outline" size="sm" className="px-3 text-rose-500 hover:bg-rose-50 hover:text-rose-600 hover:border-rose-200" title="Удалить" icon={<Trash2 className="w-4 h-4" data-id="element-11898" />} onClick={() => showToast('Товар удален')} data-id="element-11897" />
              </div>
            </div>
          </Card>)}
      </div>
    </div>;
  const renderCreateProduct = () => <div className="space-y-6 max-w-3xl" data-id="element-11899">
      <div className="flex items-center justify-between mb-2" data-id="element-11900">
        <h3 className="text-lg font-bold text-slate-900" data-id="element-11901">
          Создание нового товара
        </h3>
        <Button variant="ghost" size="sm" onClick={() => setActiveSubTab('products')} icon={<X className="w-4 h-4" data-id="element-11903" />} data-id="element-11902">
          Отмена
        </Button>
      </div>

      <Card padding="lg" className="space-y-8" data-id="element-11904">
        {/* Основное */}
        <section data-id="element-11905">
          <h4 className="text-sm font-bold text-slate-900 uppercase tracking-wider mb-4 border-b border-slate-100 pb-2" data-id="element-11906">
            1. Основная информация
          </h4>
          <div className="space-y-4" data-id="element-11907">
            <div data-id="element-11908">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-11909">
                Название товара *
              </label>
              <Input placeholder="Например: Гайд по транзитам Сатурна" value={newProduct.title} onChange={e => setNewProduct({
              ...newProduct,
              title: e.target.value
            })} data-id="element-11910" />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-11911">
              <div data-id="element-11912">
                <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-11913">
                  Тип товара *
                </label>
                <select className="w-full px-3 py-2 bg-white border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent" value={newProduct.type} onChange={e => setNewProduct({
                ...newProduct,
                type: e.target.value
              })} data-id="element-11914">
                  <option value="курс" data-id="element-11915">Курс</option>
                  <option value="pdf" data-id="element-11916">PDF-гайд / Книга</option>
                  <option value="вебинар" data-id="element-11917">Вебинар (онлайн)</option>
                  <option value="запись" data-id="element-11918">Запись вебинара</option>
                  <option value="марафон" data-id="element-11919">Марафон</option>
                  <option value="видеоурок" data-id="element-11920">Видеоурок</option>
                  <option value="чек-лист" data-id="element-11921">Чек-лист</option>
                  <option value="закрытый_клуб" data-id="element-11922">
                    Закрытый клуб (подписка)
                  </option>
                </select>
              </div>
              <div data-id="element-11923">
                <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-11924">
                  Категория
                </label>
                <Input placeholder="Например: Обучение, Отношения..." value={newProduct.category} onChange={e => setNewProduct({
                ...newProduct,
                category: e.target.value
              })} data-id="element-11925" />
              </div>
            </div>
            <div data-id="element-11926">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-11927">
                Стоимость (₽) *
              </label>
              <Input type="number" placeholder="0" value={newProduct.price} onChange={e => setNewProduct({
              ...newProduct,
              price: e.target.value
            })} data-id="element-11928" />
            </div>
          </div>
        </section>

        {/* Описание */}
        <section data-id="element-11929">
          <h4 className="text-sm font-bold text-slate-900 uppercase tracking-wider mb-4 border-b border-slate-100 pb-2" data-id="element-11930">
            2. Описание
          </h4>
          <div className="space-y-4" data-id="element-11931">
            <div data-id="element-11932">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-11933">
                Краткое описание (для карточки)
              </label>
              <textarea className="w-full px-3 py-2 bg-white border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent resize-none" rows={3} placeholder="Кратко опишите суть продукта (до 150 символов)" value={newProduct.shortDesc} onChange={e => setNewProduct({
              ...newProduct,
              shortDesc: e.target.value
            })} data-id="element-11934" />
            </div>
            <div data-id="element-11935">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-11936">
                Полное описание (для страницы товара)
              </label>
              <textarea className="w-full px-3 py-2 bg-white border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent resize-y" rows={6} placeholder="Подробно расскажите о продукте, программе, формате..." value={newProduct.fullDesc} onChange={e => setNewProduct({
              ...newProduct,
              fullDesc: e.target.value
            })} data-id="element-11937" />
            </div>
          </div>
        </section>

        {/* Материалы */}
        <section data-id="element-11938">
          <h4 className="text-sm font-bold text-slate-900 uppercase tracking-wider mb-4 border-b border-slate-100 pb-2" data-id="element-11939">
            3. Материалы для скачивания/просмотра
          </h4>
          <div className="space-y-4" data-id="element-11940">
            {materials.length > 0 && <div className="space-y-2 mb-4" data-id="element-11941">
                {materials.map((mat, idx) => <div key={idx} className="flex items-center justify-between p-3 bg-slate-50 border border-slate-200 rounded-lg" data-id="element-11942">
                    <div className="flex items-center gap-3" data-id="element-11943">
                      {mat.type === 'video' ? <Video className="w-4 h-4 text-indigo-500" data-id="element-11944" /> : mat.type === 'pdf' ? <FileText className="w-4 h-4 text-rose-500" data-id="element-11945" /> : <LinkIcon className="w-4 h-4 text-emerald-500" data-id="element-11946" />}
                      <span className="text-sm font-medium text-slate-700" data-id="element-11947">
                        {mat.name}
                      </span>
                      {mat.size && <span className="text-xs text-slate-400" data-id="element-11948">
                          ({mat.size})
                        </span>}
                    </div>
                    <button onClick={() => handleRemoveMaterial(idx)} className="text-slate-400 hover:text-rose-500 transition-colors" data-id="element-11949">
                      <X className="w-4 h-4" data-id="element-11950" />
                    </button>
                  </div>)}
              </div>}

            <div className="flex flex-col sm:flex-row gap-2 items-start sm:items-end bg-indigo-50/50 p-4 rounded-lg border border-indigo-100" data-id="element-11951">
              <div className="w-full sm:w-1/4" data-id="element-11952">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-11953">
                  Тип
                </label>
                <select className="w-full px-3 py-2 bg-white border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" value={newMaterial.type} onChange={e => setNewMaterial({
                ...newMaterial,
                type: e.target.value
              })} data-id="element-11954">
                  <option value="video" data-id="element-11955">Видео</option>
                  <option value="pdf" data-id="element-11956">PDF / Файл</option>
                  <option value="link" data-id="element-11957">Ссылка</option>
                </select>
              </div>
              <div className="w-full sm:w-2/4" data-id="element-11958">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-11959">
                  Название файла/урока
                </label>
                <Input placeholder="Напр: Урок 1. Введение" value={newMaterial.name} onChange={e => setNewMaterial({
                ...newMaterial,
                name: e.target.value
              })} data-id="element-11960" />
              </div>
              <div className="w-full sm:w-1/4" data-id="element-11961">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-11962">
                  Размер (опц.)
                </label>
                <Input placeholder="Напр: 15 MB" value={newMaterial.size} onChange={e => setNewMaterial({
                ...newMaterial,
                size: e.target.value
              })} data-id="element-11963" />
              </div>
              <Button variant="outline" className="w-full sm:w-auto mt-4 sm:mt-0" onClick={handleAddMaterial} data-id="element-11964">
                Добавить
              </Button>
            </div>
          </div>
        </section>

        {/* Аудитория */}
        <section data-id="element-11965">
          <h4 className="text-sm font-bold text-slate-900 uppercase tracking-wider mb-4 border-b border-slate-100 pb-2" data-id="element-11966">
            4. Аудитория и результаты
          </h4>
          <div className="space-y-4" data-id="element-11967">
            <div data-id="element-11968">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-11969">
                Кому подходит этот продукт?
              </label>
              <textarea className="w-full px-3 py-2 bg-white border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent resize-none" rows={2} placeholder="Например: Новичкам, которые хотят разобраться в своей натальной карте..." value={newProduct.targetAudience} onChange={e => setNewProduct({
              ...newProduct,
              targetAudience: e.target.value
            })} data-id="element-11970" />
            </div>

            <div data-id="element-11971">
              <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-11972">
                Что получит пользователь? (Буллеты)
              </label>
              {whatUserGets.length > 0 && <ul className="space-y-2 mb-3" data-id="element-11973">
                  {whatUserGets.map((item, idx) => <li key={idx} className="flex items-center gap-2 text-sm text-slate-700 bg-slate-50 px-3 py-2 rounded-lg border border-slate-100" data-id="element-11974">
                      <CheckCircle2 className="w-4 h-4 text-emerald-500 flex-shrink-0" data-id="element-11975" />
                      <span className="flex-1" data-id="element-11976">{item}</span>
                      <button onClick={() => handleRemoveBenefit(idx)} className="text-slate-400 hover:text-rose-500" data-id="element-11977">
                        <X className="w-4 h-4" data-id="element-11978" />
                      </button>
                    </li>)}
                </ul>}
              <div className="flex gap-2" data-id="element-11979">
                <Input placeholder="Например: Научится читать транзиты..." value={newBenefit} onChange={e => setNewBenefit(e.target.value)} onKeyPress={e => e.key === 'Enter' && handleAddBenefit()} data-id="element-11980" />
                <Button variant="outline" onClick={handleAddBenefit} data-id="element-11981">
                  Добавить
                </Button>
              </div>
            </div>
          </div>
        </section>

        {/* Настройки */}
        <section data-id="element-11982">
          <h4 className="text-sm font-bold text-slate-900 uppercase tracking-wider mb-4 border-b border-slate-100 pb-2" data-id="element-11983">
            5. Настройки и медиа
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-11984">
            <div data-id="element-11985">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-11986">
                Язык материалов
              </label>
              <select className="w-full px-3 py-2 bg-white border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" value={newProduct.language} onChange={e => setNewProduct({
              ...newProduct,
              language: e.target.value
            })} data-id="element-11987">
                <option value="Русский" data-id="element-11988">Русский</option>
                <option value="Английский" data-id="element-11989">Английский</option>
                <option value="Испанский" data-id="element-11990">Испанский</option>
              </select>
            </div>
            <div data-id="element-11991">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-11992">
                Обложка товара
              </label>
              <ImageUpload onUpload={file => console.log(file)} defaultImage="" aspectRatio="video" data-id="element-11993" />
            </div>
          </div>
        </section>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 pt-6 border-t border-slate-200" data-id="element-11994">
          <Button variant="outline" size="lg" className="flex-1" onClick={handleSaveDraft} data-id="element-11995">
            Сохранить черновик
          </Button>
          <Button variant="primary" size="lg" className="flex-1" onClick={handleSendToModeration} data-id="element-11996">
            Отправить на модерацию
          </Button>
        </div>
      </Card>
    </div>;
  const renderSales = () => {
    const totalSales = myOrders.length;
    const totalRevenue = myOrders.reduce((sum, order) => sum + order.priceNum, 0);
    const totalPayout = myOrders.reduce((sum, order) => sum + parseInt(order.sellerPayout.replace(/[^\d]/g, '')), 0);
    const totalCommission = totalRevenue - totalPayout;
    return <div className="space-y-4" data-id="element-11997">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-4" data-id="element-11998">
          <h3 className="text-lg font-bold text-slate-900" data-id="element-11999">История продаж</h3>
          <div className="flex bg-slate-100 p-1 rounded-lg" data-id="element-12000">
            {['Сегодня', 'Неделя', 'Месяц', 'Всё время'].map(period => <button key={period} className={`px-3 py-1.5 text-xs font-medium rounded-md transition-colors ${period === 'Всё время' ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-12001">
                {period}
              </button>)}
          </div>
        </div>

        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden" data-id="element-12002">
          <div className="overflow-x-auto" data-id="element-12003">
            <table className="w-full text-left text-sm" data-id="element-12004">
              <thead className="bg-slate-50 text-slate-500 border-b border-slate-200" data-id="element-12005">
                <tr data-id="element-12006">
                  <th className="px-4 py-3 font-medium" data-id="element-12007">Дата / ID</th>
                  <th className="px-4 py-3 font-medium" data-id="element-12008">Товар</th>
                  <th className="px-4 py-3 font-medium" data-id="element-12009">Покупатель</th>
                  <th className="px-4 py-3 font-medium" data-id="element-12010">Сумма</th>
                  <th className="px-4 py-3 font-medium" data-id="element-12011">Комиссия</th>
                  <th className="px-4 py-3 font-medium" data-id="element-12012">Начислено</th>
                  <th className="px-4 py-3 font-medium" data-id="element-12013">Доступ</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-12014">
                {myOrders.map(order => <tr key={order.id} className="hover:bg-slate-50" data-id="element-12015">
                    <td className="px-4 py-3" data-id="element-12016">
                      <div className="text-slate-900 font-medium" data-id="element-12017">
                        {order.createdAt.split(',')[0]}
                      </div>
                      <div className="text-xs text-slate-500" data-id="element-12018">{order.id}</div>
                    </td>
                    <td className="px-4 py-3" data-id="element-12019">
                      <div className="font-medium text-slate-900 line-clamp-1" title={order.productTitle} data-id="element-12020">
                        {order.productTitle}
                      </div>
                      <div className="text-xs text-slate-500 capitalize" data-id="element-12021">
                        {order.productType}
                      </div>
                    </td>
                    <td className="px-4 py-3 text-slate-600" data-id="element-12022">
                      {order.buyerName}
                    </td>
                    <td className="px-4 py-3 font-medium text-slate-900" data-id="element-12023">
                      {order.price}
                    </td>
                    <td className="px-4 py-3 text-rose-500 text-xs" data-id="element-12024">
                      -{order.commissionAmount} ({order.platformCommission}%)
                    </td>
                    <td className="px-4 py-3 font-bold text-emerald-600" data-id="element-12025">
                      {order.sellerPayout}
                    </td>
                    <td className="px-4 py-3" data-id="element-12026">
                      <Badge variant={order.accessStatus === 'granted' ? 'success' : order.accessStatus === 'pending' ? 'warning' : 'error'} size="sm" data-id="element-12027">
                        {order.accessStatus === 'granted' ? 'Открыт' : order.accessStatus === 'pending' ? 'Ожидание' : 'Отозван'}
                      </Badge>
                    </td>
                  </tr>)}
              </tbody>
              <tfoot className="bg-slate-50 border-t border-slate-200 font-bold" data-id="element-12028">
                <tr data-id="element-12029">
                  <td colSpan={3} className="px-4 py-3 text-right text-slate-700" data-id="element-12030">
                    Итого за период:
                  </td>
                  <td className="px-4 py-3 text-slate-900" data-id="element-12031">
                    {totalRevenue.toLocaleString('ru-RU')} ₽
                  </td>
                  <td className="px-4 py-3 text-rose-500" data-id="element-12032">
                    -{totalCommission.toLocaleString('ru-RU')} ₽
                  </td>
                  <td className="px-4 py-3 text-emerald-600" data-id="element-12033">
                    {totalPayout.toLocaleString('ru-RU')} ₽
                  </td>
                  <td data-id="element-12034"></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>;
  };
  const renderBalance = () => <div className="space-y-6" data-id="element-12035">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-12036">
        <Card padding="md" className="bg-indigo-50/50 border-indigo-100 flex flex-col" data-id="element-12037">
          <div className="text-sm text-slate-500 mb-1 font-medium" data-id="element-12038">
            Доступно к выводу
          </div>
          <div className="text-3xl font-bold text-indigo-700 mb-4" data-id="element-12039">
            45 000 ₽
          </div>
          <Button className="mt-auto w-full" onClick={() => showToast('Заявка на выплату создана')} data-id="element-12040">
            Вывести средства
          </Button>
        </Card>
        <Card padding="md" className="bg-slate-50 border-slate-200 flex flex-col" data-id="element-12041">
          <div className="flex items-center gap-2 text-sm text-slate-500 mb-1 font-medium" data-id="element-12042">
            В ожидании (Hold)
            <AlertCircle className="w-3.5 h-3.5" title="Средства заморожены на 14 дней для защиты от возвратов" data-id="element-12043" />
          </div>
          <div className="text-3xl font-bold text-slate-700 mb-2" data-id="element-12044">3 920 ₽</div>
          <div className="text-xs text-slate-500 mt-auto" data-id="element-12045">
            Станут доступны через 14 дней после покупки
          </div>
        </Card>
        <Card padding="md" className="bg-rose-50/30 border-rose-100 flex flex-col" data-id="element-12046">
          <div className="text-sm text-slate-500 mb-1 font-medium" data-id="element-12047">
            Удержано комиссий
          </div>
          <div className="text-3xl font-bold text-rose-600 mb-2" data-id="element-12048">550 000 ₽</div>
          <div className="text-xs text-slate-500 mt-auto" data-id="element-12049">
            За всё время работы
          </div>
        </Card>
        <Card padding="md" className="bg-emerald-50/50 border-emerald-100 flex flex-col" data-id="element-12050">
          <div className="text-sm text-slate-500 mb-1 font-medium" data-id="element-12051">
            Выплачено всего
          </div>
          <div className="text-3xl font-bold text-emerald-700 mb-2" data-id="element-12052">
            2 600 000 ₽
          </div>
          <div className="text-xs text-emerald-600 mt-auto font-medium" data-id="element-12053">
            Успешно переведено
          </div>
        </Card>
      </div>

      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden mt-8" data-id="element-12054">
        <div className="px-5 py-4 border-b border-slate-200 bg-slate-50 flex justify-between items-center" data-id="element-12055">
          <h3 className="font-bold text-slate-900" data-id="element-12056">История выплат</h3>
          <Button variant="outline" size="sm" icon={<Download className="w-4 h-4" data-id="element-12058" />} data-id="element-12057">
            Скачать акт
          </Button>
        </div>
        <div className="overflow-x-auto" data-id="element-12059">
          <table className="w-full text-left text-sm" data-id="element-12060">
            <thead className="bg-white text-slate-500 border-b border-slate-100" data-id="element-12061">
              <tr data-id="element-12062">
                <th className="px-5 py-3 font-medium" data-id="element-12063">ID Выплаты</th>
                <th className="px-5 py-3 font-medium" data-id="element-12064">Сумма</th>
                <th className="px-5 py-3 font-medium" data-id="element-12065">Дата запроса</th>
                <th className="px-5 py-3 font-medium" data-id="element-12066">Статус</th>
                <th className="px-5 py-3 font-medium" data-id="element-12067">Транзакция</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-12068">
              {myPayouts.map(payout => <tr key={payout.id} className="hover:bg-slate-50" data-id="element-12069">
                  <td className="px-5 py-3 font-medium text-slate-900" data-id="element-12070">
                    {payout.id}
                  </td>
                  <td className="px-5 py-3 font-bold text-slate-900" data-id="element-12071">
                    {payout.amount}
                  </td>
                  <td className="px-5 py-3 text-slate-500" data-id="element-12072">
                    {payout.createdAt}
                  </td>
                  <td className="px-5 py-3" data-id="element-12073">
                    <Badge variant={payout.status === 'paid_out' ? 'success' : payout.status === 'pending' ? 'warning' : 'error'} size="sm" data-id="element-12074">
                      {payout.status === 'paid_out' ? 'Выплачено' : payout.status === 'pending' ? 'В обработке' : 'Ошибка'}
                    </Badge>
                  </td>
                  <td className="px-5 py-3 text-xs text-slate-400 font-mono" data-id="element-12075">
                    {payout.transactionId || '—'}
                  </td>
                </tr>)}
              {myPayouts.length === 0 && <tr data-id="element-12076">
                  <td colSpan={5} className="px-5 py-8 text-center text-slate-500" data-id="element-12077">
                    У вас пока нет истории выплат
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
      </div>

      <Card padding="md" className="bg-slate-50 border-slate-200" data-id="element-12078">
        <h4 className="font-bold text-slate-900 mb-2" data-id="element-12079">
          Информация о комиссиях платформы
        </h4>
        <p className="text-sm text-slate-600 mb-4" data-id="element-12080">
          Платформа удерживает комиссию с каждой продажи для покрытия расходов
          на эквайринг, хостинг материалов, маркетинг и поддержку пользователей.
        </p>
        <ul className="space-y-2 text-sm text-slate-700" data-id="element-12081">
          <li className="flex justify-between border-b border-slate-200 pb-2" data-id="element-12082">
            <span data-id="element-12083">Базовая комиссия (Курсы, Вебинары, Марафоны)</span>
            <span className="font-bold" data-id="element-12084">15%</span>
          </li>
          <li className="flex justify-between border-b border-slate-200 pb-2" data-id="element-12085">
            <span data-id="element-12086">Цифровые файлы (PDF, Чек-листы)</span>
            <span className="font-bold" data-id="element-12087">20%</span>
          </li>
          <li className="flex justify-between pt-1" data-id="element-12088">
            <span data-id="element-12089">Закрытые клубы (Подписки)</span>
            <span className="font-bold" data-id="element-12090">10%</span>
          </li>
        </ul>
      </Card>
    </div>;
  const renderAnalytics = () => <div className="space-y-6" data-id="element-12091">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-12092">
        <Card padding="md" className="flex flex-col justify-center" data-id="element-12093">
          <div className="text-sm text-slate-500 mb-1" data-id="element-12094">Конверсия в покупку</div>
          <div className="flex items-end gap-2" data-id="element-12095">
            <div className="text-3xl font-bold text-slate-900" data-id="element-12096">4.2%</div>
            <div className="text-sm text-emerald-500 font-medium mb-1 flex items-center" data-id="element-12097">
              <TrendingUp className="w-3 h-3 mr-1" data-id="element-12098" /> +0.5%
            </div>
          </div>
          <div className="text-xs text-slate-400 mt-2" data-id="element-12099">
            Из просмотра карточки в оплату
          </div>
        </Card>
        <Card padding="md" className="flex flex-col justify-center" data-id="element-12100">
          <div className="text-sm text-slate-500 mb-1" data-id="element-12101">Средний рейтинг</div>
          <div className="flex items-end gap-2" data-id="element-12102">
            <div className="text-3xl font-bold text-slate-900" data-id="element-12103">4.9</div>
            <Star className="w-6 h-6 text-amber-400 fill-amber-400 mb-1" data-id="element-12104" />
          </div>
          <div className="text-xs text-slate-400 mt-2" data-id="element-12105">
            На основе 83 отзывов
          </div>
        </Card>
        <Card padding="md" className="flex flex-col justify-center" data-id="element-12106">
          <div className="text-sm text-slate-500 mb-1" data-id="element-12107">Возвраты</div>
          <div className="flex items-end gap-2" data-id="element-12108">
            <div className="text-3xl font-bold text-slate-900" data-id="element-12109">1.1%</div>
            <div className="text-sm text-rose-500 font-medium mb-1 flex items-center" data-id="element-12110">
              <TrendingUp className="w-3 h-3 mr-1" data-id="element-12111" /> +0.2%
            </div>
          </div>
          <div className="text-xs text-slate-400 mt-2" data-id="element-12112">
            Доля возвратов от всех продаж
          </div>
        </Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-12113">
        <Card padding="md" data-id="element-12114">
          <h3 className="font-bold text-slate-900 mb-6" data-id="element-12115">
            Продажи за последние 7 дней
          </h3>
          <div className="h-64 flex items-end gap-2 justify-between px-2" data-id="element-12116">
            {[4500, 12000, 8900, 15000, 21000, 18500, 24000].map((val, i) => {
            const height = val / 24000 * 100;
            const days = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
            return <div key={i} className="flex flex-col items-center gap-2 flex-1" data-id="element-12117">
                  <div className="w-full bg-indigo-100 rounded-t-sm relative group hover:bg-indigo-200 transition-colors" style={{
                height: `${height}%`
              }} data-id="element-12118">
                    <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 bg-slate-800 text-white text-xs py-1 px-2 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-10 pointer-events-none" data-id="element-12119">
                      {val.toLocaleString('ru-RU')} ₽
                    </div>
                  </div>
                  <div className="text-xs text-slate-500" data-id="element-12120">{days[i]}</div>
                </div>;
          })}
          </div>
        </Card>

        <Card padding="md" data-id="element-12121">
          <h3 className="font-bold text-slate-900 mb-6" data-id="element-12122">
            Топ товаров по доходу
          </h3>
          <div className="space-y-5" data-id="element-12123">
            {myProducts.sort((a, b) => b.priceNum * b.salesCount - a.priceNum * a.salesCount).slice(0, 4).map((product, i) => {
            const maxRev = myProducts[0].priceNum * myProducts[0].salesCount;
            const rev = product.priceNum * product.salesCount;
            const pct = rev / maxRev * 100;
            return <div key={product.id} data-id="element-12124">
                    <div className="flex justify-between text-sm mb-1" data-id="element-12125">
                      <span className="font-medium text-slate-700 truncate pr-4" data-id="element-12126">
                        {i + 1}. {product.title}
                      </span>
                      <span className="font-bold text-slate-900 flex-shrink-0" data-id="element-12127">
                        {product.revenue}
                      </span>
                    </div>
                    <div className="w-full bg-slate-100 rounded-full h-2" data-id="element-12128">
                      <div className="bg-indigo-500 h-2 rounded-full" style={{
                  width: `${pct}%`
                }} data-id="element-12129"></div>
                    </div>
                  </div>;
          })}
          </div>
        </Card>
      </div>
    </div>;
  return <div className="space-y-6" data-id="element-12130">
      <div className="flex justify-between items-center mb-2" data-id="element-12131">
        <h2 className="text-2xl font-bold text-slate-900" data-id="element-12132">Мой маркетплейс</h2>
      </div>

      {activeSubTab !== 'create' && renderTopStats()}

      <div className="flex gap-2 border-b border-slate-200 pb-px overflow-x-auto scrollbar-hide" data-id="element-12133">
        {[{
        id: 'products',
        label: 'Мои товары',
        icon: Package
      }, {
        id: 'sales',
        label: 'Продажи',
        icon: ShoppingBag
      }, {
        id: 'balance',
        label: 'Баланс и выплаты',
        icon: DollarSign
      }, {
        id: 'analytics',
        label: 'Аналитика',
        icon: BarChart3
      }].map(tab => <button key={tab.id} onClick={() => setActiveSubTab(tab.id as any)} className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-t-lg transition-colors whitespace-nowrap ${activeSubTab === tab.id ? 'bg-white border border-slate-200 border-b-white text-indigo-600 -mb-px relative z-10' : 'text-slate-500 hover:text-slate-700 hover:bg-slate-50 border border-transparent'}`} data-id="element-12134">
            <tab.icon className="w-4 h-4" data-id="element-12135" />
            {tab.label}
          </button>)}
      </div>

      <div className="pt-2" data-id="element-12136">
        {activeSubTab === 'products' && renderProducts()}
        {activeSubTab === 'create' && renderCreateProduct()}
        {activeSubTab === 'sales' && renderSales()}
        {activeSubTab === 'balance' && renderBalance()}
        {activeSubTab === 'analytics' && renderAnalytics()}
      </div>
    </div>;
}